import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import BottomNav from "../../../../containers/BottomNav";
import GamesSearchModal from "../../../components/GamesSearchModal";
import { SlotGames } from "../../../../lib/data/SlotGames.data";
import { PragmaticPlayGames } from "../../../../lib/data/PragmaticplayGames.data";

const Casino = () => {
  const navigate = useNavigate();
  const categoriesTab = [
    { name: "All", key: "all" },
    { name: "NetEnt", key: "netenttab" },
    { name: "Red Tiger", key: "redtigertab" },
    { name: "Pragmatic Play", key: "PragmaticPlayGames" },
  ];
  const [activeCategory, setActiveCategory] = useState("all");

  // **Get Games for Active Category**
  // const filteredGames =
  //   activeCategory === "all"
  //     ? [
  //         ...Object.values(SlotGames.netenttab || []),
  //         ...Object.values(SlotGames.redtigertab || []),
  //         ...Object.values(SlotGames.jiliGaming || []),
  //         ...Object.values(PragmaticPlayGames || []),
  //       ]
  //     : SlotGames[activeCategory]
  //     ? Object.values(SlotGames[activeCategory])
  //     : [];

  const filteredGames = (() => {
    if (activeCategory === "all") {
      return [
        ...Object.values(SlotGames.netenttab || []),
        ...Object.values(SlotGames.redtigertab || []),
        ...Object.values(SlotGames.jiliGaming || []),
        ...Object.values(PragmaticPlayGames || []),
      ];
    }

    // If category belongs to SlotGames
    if (SlotGames[activeCategory]) {
      return Object.values(SlotGames[activeCategory]);
    }

    // If category is Pragmatic Play
    if (activeCategory === "PragmaticPlayGames") {
      return Object.values(PragmaticPlayGames);
    }

    return [];
  })();

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="prvdr-game-page">
          <div className="games-heading">
            <h3>Slots</h3>
            <div className="d-none d-lg-block">
              <GamesSearchModal />
            </div>
          </div>

          {/* CATEGORY TABS */}
          <ul className="tabs">
            {categoriesTab.map((tab, index) => (
              <li
                key={index}
                onClick={() => {
                  if (tab?.redirectUrl) {
                    navigate(tab?.redirectUrl);
                  } else {
                    setActiveCategory(tab.key);
                  }
                }}
              >
                <a
                  href="#"
                  className={activeCategory === tab.key ? "active" : ""}
                >
                  {tab.name}
                </a>
              </li>
            ))}
          </ul>

          {/* GAMES LIST */}
          <ul className="gamelisting">
            {filteredGames.length > 0 ? (
              filteredGames.map((game, idx) => (
                <li key={"casinogame" + idx}>
                  <a href={game.redirectUrl}>
                    <img src={game.imgUrl} alt={game.alt} />
                    <div className="providerName">{game.providerName}</div>
                    <div className="GameName">{game.name}</div>
                  </a>
                </li>
              ))
            ) : (
              <p>No games available for this category.</p>
            )}
          </ul>
        </div>
      </main>

      <BottomNav />
    </>
  );
};

export default Casino;
